export default {
  destinations: [],
  destinationsLoading: false
}
